import React from 'react';
import { FormControl, MenuItem, Select, InputLabel } from '@mui/material';
import { alpha } from '@mui/material/styles';

function FilterSingleSelect({ label, value, onChange, options, maxCharacters = 30, sx }) {
    return (
        <FormControl variant="outlined" color="primary" size="small" sx={{ minWidth: 200, ...sx }}>
            <InputLabel
                sx={{
                    fontSize: '13px',
                    fontWeight: 700,
                    top: '4px',
                    left: '-4px',
                    width: '100%',
                    color: alpha('#3b3c3b', 0.6),
                }}
            >
                {label}
            </InputLabel>
            <Select
                label={label}
                variant="outlined"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                renderValue={(selected) => {
                    const selectedOption = options.find((o) => o.value === selected);
                    if (!selectedOption) return '';
                    const text = selectedOption.name;
                    return text.length > maxCharacters
                        ? `${text.slice(0, maxCharacters)}...`
                        : text;
                }}
            >
                {options.map((opt) => (
                    <MenuItem
                        key={opt.value}
                        value={opt.value}
                        sx={{ paddingTop: 0.5, paddingBottom: 0.5 }}
                    >
                        {opt.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default FilterSingleSelect;
